type ErrorMessageProps = {
  children: string;
  id?: string;
};

export function ErrorMessage({ children, id }: ErrorMessageProps) {
  return (
    <p className="hw-error" role="alert" id={id}>
      {children}
    </p>
  );
}
